import { api } from '../http.api';
import {
  IProfessionalFisherNetName,
  IProfessionalFisherNetNameCreatePayload,
  IProfessionalFisherNetTypeOption,
  IProfessionalFisherNetNameUpdatePayload,
} from '@app/interfaces/professionalFisher';

export interface INetTypeEntrypointData {
  netTypeOptions: IProfessionalFisherNetTypeOption[];
}

const base = '/web/admin/professional_fisher/net_type';

export const getAllNetNames = async (): Promise<{ error: boolean; data?: IProfessionalFisherNetName[] }> => {
  try {
    const { data } = await api.get(`${base}/`);

    return { error: false, data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching professional fisher net names:', error);
    return { error: true, data: undefined };
  }
};

export const getNetTypeEntrypoint = async (): Promise<{ error: boolean; data?: INetTypeEntrypointData }> => {
  try {
    const { data } = await api.get(`${base}/entrypoint`);

    return { error: false, data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching professional fisher net type entrypoint:', error);
    return { error: true };
  }
};

export const createNetNames = async (
  payload: IProfessionalFisherNetNameCreatePayload[],
): Promise<{ error: boolean; data?: IProfessionalFisherNetName[] }> => {
  try {
    const { data } = await api.post(`${base}/`, payload);

    return { error: false, data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error creating professional fisher net names:', error);
    return { error: true };
  }
};

export const updateNetName = async (
  id: string,
  payload: IProfessionalFisherNetNameUpdatePayload,
): Promise<{ error: boolean; data?: IProfessionalFisherNetName }> => {
  try {
    const { data } = await api.put(`${base}/${id}`, payload);

    return { error: false, data };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error updating professional fisher net name:', error);
    return { error: true };
  }
};

export const deleteNetName = async (id: string): Promise<{ error: boolean }> => {
  try {
    await api.delete(`${base}/${id}`);

    return { error: false };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error deleting professional fisher net name:', error);
    return { error: true };
  }
};
